import "./Footer.scss"
const Footer = () => {
  return (
    <footer>
      <p className="">Copyright by UmitDev {new Date().getFullYear()}</p>
    </footer>
  )
}

export default Footer